import { FormGroup, TextInput } from '@ksyos/design-system';
import type { ValidationErrors } from '@frontend/utils';
import { getSelectedLanguage } from '@frontend/translate';
import { getValidationErrorTranslation } from '@frontend/utils';

type IdentifierSocialSecurityProps = {
    errors: ValidationErrors;
    identifierSocialSecurity?: string;
    onChangeIdentifierSocialSecurity: (value: string | undefined) => void;
};

export function IdentifierSocialSecurityFilter(props: IdentifierSocialSecurityProps) {
    const language = getSelectedLanguage();

    return (
        <FormGroup
            hasErrors={props.errors.has('identifierSocialSecurity')}
            label={language.processSearchField.identifierSocialSecurity}
        >
            <TextInput
                error={getValidationErrorTranslation(props.errors.get('identifierSocialSecurity'))}
                id="identifierSocialSecurity"
                onChange={(event) => {
                    props.onChangeIdentifierSocialSecurity(event.target.value);
                }}
                value={props.identifierSocialSecurity || ''}
            />
        </FormGroup>
    );
}
